import React, { FC } from 'react';
import { ApprovalModalComponenetProps } from './ApprovalModalComponenetProps';
import Modal, { Sheets, ModalFooter, ModalBody } from '@ingka/modal';
import Button from '@ingka/button';
import useTranslation from '../../hooks/useTranslation';
import { Stack } from '@mui/material';
import ApprovalModalIsepStatus from '../ApprovalModalIsepStatus';
import ApprovalModalPartOfFda from '../ApprovalModalPartOfFda';
import Divider from '../Divider';
import ApprovalModalGexFields from '../ApprovalModalGexFields';
import ApprovalModalFundedBy from '../ApprovalModalFundedBy';
import ApprovalModalOCNPriority from '../ApprovalModalOCNPriority';
import ApprovalModalGexComment from '../ApprovalModalGexComment';
import ISEPStatusSection from '../ISEPStatusSection';
import ApprovalModalValidationFields from '../ApprovalModalValidationFields';
import NotSyncedWithEtr from '../NotSyncedWithETR';

const ApprovalModalComponenet: FC<ApprovalModalComponenetProps> = ({
  visible,
  onCloseHandler,
  submitHandler,
  project,
  isep,
  setIsep,
  partOfFda,
  setPartOfFda,
  gex,
  gexDates,
  setGex,
  fundedBy,
  setFundedBy,
  ocnPriority,
  setOcnPriority,
  gexComment,
  setGexComment,
  isepStatus,
  setIsepStatus,
  validationComment,
  setValidationComment,
  validation,
  setValidation,
  subPortfolio,
  setSubPortfolio,
  showDirectiveCaution,
}) => {
  const t = useTranslation();
  return (
    <Modal visible={visible} handleCloseBtn={onCloseHandler}>
      <Sheets
        size={'small'}
        header={null}
        footer={
          <ModalFooter>
            <Stack
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'space-between'}
              gap={2}
            >
              <Button
                text={t('common.close')}
                type="secondary"
                onClick={onCloseHandler}
                style={{ marginBottom: 0 }}
              />
              <Button
                text={t('common.save')}
                type="primary"
                onClick={submitHandler}
              />
            </Stack>
          </ModalFooter>
        }
      >
        <ModalBody style={{ padding: '16px' }}>
          <NotSyncedWithEtr
            synced={project ? project?.etrSynced : true}
            source={project?.projectSource}
          />
          <ApprovalModalIsepStatus
            project={project}
            isep={isep}
            setIsep={setIsep}
            showDirectiveCaution={showDirectiveCaution}
          />
          <Divider />
          <ApprovalModalPartOfFda
            project={project}
            partOfFda={partOfFda}
            setPartOfFda={setPartOfFda}
          />
          <Divider />
          {isep && (
            <>
              <ISEPStatusSection
                isepStatus={isepStatus}
                setIsepStatus={setIsepStatus}
              />
              <Divider />
            </>
          )}
          <ApprovalModalValidationFields
            validationComment={validationComment}
            setValidation={setValidation}
            validation={validation}
            setValidationComment={setValidationComment}
            setSubPortfolio={setSubPortfolio}
            subPortfolio={subPortfolio}
          />
          <Divider />
          <ApprovalModalGexFields
            gex={gex}
            gexDates={gexDates}
            setGex={setGex}
          />
          <Divider />
          <ApprovalModalFundedBy
            fundedBy={fundedBy}
            setFundedBy={setFundedBy}
          />
          <Divider />
          <ApprovalModalOCNPriority
            ocnPriority={ocnPriority}
            setOcnPriority={setOcnPriority}
          />
          <Divider />
          <ApprovalModalGexComment
            gexComment={gexComment}
            setGexComment={setGexComment}
          />
        </ModalBody>
      </Sheets>
    </Modal>
  );
};

export default ApprovalModalComponenet;
